import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { HOME_URL } from '../../scripts/navigationItems';

const PageNotFound = () => (
	<Container align='center' sx={{ my: { xs: 3, md: 5 } }}>
		<Typography variant='h1'>404</Typography>
		<Typography variant='h3' component='h2'>
			Page not found
		</Typography>
		<Typography
			sx={{ my: { xs: 1, md: 2 } }}
			variant='body3'
			data-testid='page-not-found-message'
		>
			We&apos;re sorry, the page you are looking for doesn&apos;t exist or
			an error occured
		</Typography>
		<Button
			sx={{ mt: { xs: 1, md: 2 } }}
			variant='contained'
			component={RouterLink}
			to={HOME_URL}
			target='_self'
		>
			Back to Home
		</Button>
	</Container>
);

export default PageNotFound;
